import { useEffect, useState } from "react";

function useMediaQuery(query: string) {
    const [match, setMatch] = useState<boolean>(() => window.matchMedia(query).matches);
    useEffect(() => {
        const mql = window.matchMedia(query);
        const onChange = (e: MediaQueryListEvent) => setMatch(e.matches);
        mql.addEventListener("change", onChange);
        return () => mql.removeEventListener("change", onChange);
    }, [query]);
    return match;
}

export default useMediaQuery;
